import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { useIntl } from "react-intl";

export type ConfirmDialogProps = {
  open: boolean;
  onClose: () => void;
  title: string;
  message: string;
  okAction: () => void;
  okLabel?: string;
  cancelLabel?: string;
  color?: "inherit" | "primary" | "secondary" | "success" | "error" | "info" | "warning";
};

export const ConfirmDialog = ({ open, onClose, title, message, okAction, okLabel, cancelLabel, color }: ConfirmDialogProps) => {
  const { formatMessage } = useIntl();

  return (
    <Dialog open={open} onClose={onClose} sx={{ '.MuiDialogTitle-root': {backgroundColor: `${color}.main`} }}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">
          {cancelLabel ?? formatMessage({ defaultMessage: "Cancel" })}
        </Button>
        <Button onClick={okAction} color={color}>
          {okLabel ?? formatMessage({ defaultMessage: "OK" })}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
